import { Layout, Sidebar } from "react-admin";
import MyAppBar from "./MyAppBar";
import MyMenu from "./MyMenu";
const MySidebar = (props) => (
  <Sidebar
    {...props}
    sx={(theme) => ({
      borderRight: `1px solid ${
        theme.palette.mode === "dark"
          ? theme.palette.divider
          : "rgba(0,0,0,0.12)"
      }`,
      boxShadow:
        theme.palette.mode === "dark"
          ? "2px 0 8px rgba(0,0,0,0.6)"
          : "2px 0 5px -2px rgba(0,0,0,0.1)",
      backgroundColor:
        theme.palette.mode === "dark"
          ? theme.palette.background.default
          : "#f8f9fa",
    })}
  />
);

const MyLayout = (props) => (
  <Layout
    {...props}
    appBar={MyAppBar}
    sidebar={MySidebar}
    menu={MyMenu}
  />
);

export default MyLayout;
